/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { SettingsSecurityAction, SettingsSecurityActionType } from '../actions/settingsSecurityActions';

export interface SettingsSecurityState {
    isLoading: boolean;
    isError: boolean;
}

const initialState: SettingsSecurityState = {
    isLoading: false,
    isError: false,
};

export function settingsSecurityReducer(
    state: SettingsSecurityState = initialState,
    action: SettingsSecurityAction,
): SettingsSecurityState {
    switch (action.type) {
        case SettingsSecurityActionType.OPEN_SETTINGS_SECURITY_PAGE:
            return {
                ...state,
            };

        case SettingsSecurityActionType.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
            };

        case SettingsSecurityActionType.CHANGE_PASSWORD:
            return {
                ...state,
                isLoading: true,
                isError: false,
            };

        case SettingsSecurityActionType.CHANGE_PASSWORD_ERROR:
            return {
                ...state,
                isLoading: false,
                isError: true,
            };

        case SettingsSecurityActionType.EXIT_SETTINGS_SECURITY_PAGE:
            return {
                ...state,
                isError: false,
            };

        default:
            break;
    }

    return state;
}
